import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu_mgr",
  "use": "icon-menu_mgr-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-menu_mgr\"><path d=\"M51.09,73a5,5,0,0,1,4.95,5V113a5,5,0,0,1-4.95,5H16a5,5,0,0,1-4.95-5V77.91A5,5,0,0,1,16,73Zm56.2,0a5,5,0,0,1,4.95,5V113a5,5,0,0,1-4.95,5H72.22a5,5,0,0,1-4.94-5V77.91a5,5,0,0,1,4.94-5Zm-14-62,24.8,24.8a4.94,4.94,0,0,1,0,7l-24.8,24.8a4.94,4.94,0,0,1-7,0l-24.8-24.8a4.94,4.94,0,0,1,0-7L86.26,11a4.94,4.94,0,0,1,7,0ZM51.09,16.76A5,5,0,0,1,56,21.71V56.78a5,5,0,0,1-4.95,4.94H16a5,5,0,0,1-4.95-4.94V21.71A5,5,0,0,1,16,16.76Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol